import type { CinematicOverrides } from '../../../renderer/src/cinematic-sequence';
import { CAMERA_TRACK_LIMITS, cameraLensMillimeters, evaluateAuthoredCameraTrack } from '../domain/camera-keyframes';
import type { CameraPose } from '../domain/camera-plan';
import type { CinematicSettings } from '../domain/cinematic-plan';
import { automaticCameraAttributes } from '../map/attribute-camera';
import { upsertAttributeKey } from './camera-tracks/camera-animation';
import type { StudioDraft } from './studio-draft';

export const STRUCTURES_ALTITUDE = 200;
export const STRUCTURES_TILT = 55;
export const STRUCTURES_LENS = 50;
export const structuresOverrides = (): CinematicOverrides => ({ mapStyle: 'relief', cameraDistance: 'standard',
  cameraAngle: STRUCTURES_TILT, cameraZoom: null });

/** Initialize the selected frame without replacing independent camera tracks. */
export function initializeStructuresView(draft: StudioDraft, pose: CameraPose, settings: CinematicSettings,
  progress: number, duration: number): StudioDraft {
  const seconds = progress * duration;
  const base = automaticCameraAttributes(pose, cameraLensMillimeters(settings.cameraDistance), 1080);
  let tracks = draft.cinematicSequence.cameraTracks;
  for (const [axis, value] of [['lens', STRUCTURES_LENS], ['altitude', STRUCTURES_ALTITUDE], ['tilt', STRUCTURES_TILT]] as const) {
    const baseline = tracks ? evaluateAuthoredCameraTrack(tracks, axis, seconds, () => base[axis]) ?? base[axis] : base[axis];
    const limits = CAMERA_TRACK_LIMITS[axis];
    tracks = upsertAttributeKey(tracks, axis, seconds, Math.max(limits.min, Math.min(limits.max, value)), baseline, duration).tracks;
  }
  return { ...draft, cinematicSequence: { ...draft.cinematicSequence, cameraTracks: tracks! } };
}
